import type { Room } from '@studio/models/room';
import type { T_Maybe } from '@tryiris-ai/js-types';
import { createContext } from 'react';

/** @internal */
export const Context = createContext<T_Maybe<Room['id']>>(undefined);
